var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.active,
      expression: "active"
    }]
  }, [_vm.list.length ? _c('GGGroup', {
    scopedSlots: _vm._u([{
      key: "content",
      fn: function () {
        return [_c('RowSliderNew', {
          staticClass: "row-slider_news",
          attrs: {
            "list": _vm.list,
            "offset-between-elements": 10
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function (_ref) {
              var el = _ref.el;
              return [_c('NewsCard', {
                attrs: {
                  "image": el.image,
                  "name": el.name,
                  "link": ("/sales/" + (el.code) + "/")
                },
                nativeOn: {
                  "click": function ($event) {
                    return _vm.saleSelect();
                  }
                }
              })];
            }
          }], null, false, 3539773225)
        })];
      },
      proxy: true
    }], null, false, 1522758719)
  }) : _vm._e()], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }